import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from '../layouts/dashboard';
import SimpleLayout from '../layouts/simple';

// ---------------------------------------------------------------- ADMIN PAGE ------
import UserPage from '../pages/UserPage';
import EventPage from '../pages/EventPage';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import Page404 from '../pages/Page404';
import ProductsPage from '../pages/ProductsPage';

// ---------------------------------------------------------------- CLIENT PAGE ------
import HomePage from '../pages/client/EventPage';
import HomeLayout from '../layouts/home';
import TicketPage from '../pages/client/Ticket';

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/users" />, index: true },
        { path: 'users', element: <UserPage /> },
        { path: 'events', element: <EventPage /> },
        { path: 'tickets', element: <ProductsPage /> },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '/home',
      element: <HomeLayout />,
      children: [
        { element: <Navigate to="/home/events" />, index: true },
        { path: 'events', element: <HomePage /> },
        { path: 'events/:_id/listTickets', element: <TicketPage /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'register',
      element: <RegisterPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
